import { useCallback, useState } from "react";
import { IFuneral, IStar } from "../services/api/mourning-card/interfaces";
import { starApi } from "../services/api/starApi";

export const useFetchStar = (starUuid: string) => {
  const [star, setStar] = useState<IStar | null>(null);
  const [funeral, setFuneral] = useState<IFuneral & {
    date: Date;
    time: string;
    document: string;
  } | null>(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<unknown | null>(null);

  const fetchStar = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await starApi.getStar(starUuid);

      setStar(response.star);
      setFuneral(response.funeral);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [starUuid]);

  return {
    star,
    funeral,
    starLoading: loading,
    starError: error,
    fetchStar
  };
};
